export const serviceHistoryHover = 'history';
export const serviceHistoryAlt = 'history button';
export const serviceHistoryModal = 'Service history';
